<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\endCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面上部の[学習進捗]をクリックすると、修了依頼画面が表示されます。</p>
                    <p>※ 修了試験終了後、自動的に「修了依頼」画面が表示され、アンケートシートまたはコミットメントステートメントがある場合は表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\endCourseManual-2.png" alt="" /></div>
                <div>
                    <p>② コースの進捗状況を確認します。</p>
                    <p>③ 学習全体が完成すると、[申請]ボタンがアクティブになります。 [申請]ボタンを押すとコースが終了します。</p>
                    <p>※ コースが終了すると、修了試験に戻ることはできません。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                typeLanguage: 3,
            };
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/endCourse_manual.vue